/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _regionAlign = _interopRequireDefault(require("../../packages/region-align"));
var _selectParent = _interopRequireDefault(require("../selectParent"));
var _getViewportRegion = _interopRequireDefault(require("../getViewportRegion"));
function _default(constrainTo, domNode) {
  var constrainRegion;
  if (constrainTo === true) {
    constrainRegion = (0, _getViewportRegion.default)();
  }
  if (!constrainRegion && typeof constrainTo === 'function') {
    constrainTo = _regionAlign.default.from(constrainTo(domNode));
  }
  if (!constrainRegion && typeof constrainTo === 'string') {
    constrainTo = (0, _selectParent.default)(constrainTo, domNode);
  }
  if (!constrainRegion && constrainTo) {
    constrainRegion = _regionAlign.default.from(constrainTo);
  }
  return constrainRegion;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/getPositionRelativeToElement/getConstrainRegion.js
// module id = 584
// module chunks = 0